import { ScoreConfig } from './score-config.interface';

export interface IExtraLogs
    extends ITripFinishedExtra,
        ITripScheduledStartChangedExtra,
        IStepSkippedExtra,
        IStepPlannedAtChangedExtra,
        IVehicleAssignedExtra,
        IVehicleChangedExtra,
        IDriverAssignedExtra,
        IDriverChangedExtra,
        IVehiclePositionExtra,
        ILocationChangedExtra,
        ICheckpointReorderedExtra,
        IStopsExtra,
        ITripStatusChangedExtra,
        ISatelliteEntityNotFoundExtra,
        IUnitChangedExtra,
        ILocationMissingZonesExtra,
        IUnfoldExtra,
        IScoreConfigChangeExtra {
    apiKey?: string;
}

interface IUnitChangedExtra {
    checkpointName?: string;
    sectionNumber?: string;
    previousCarrierName?: string;
    updatedCarrierName?: string;
    previousSemitrailerName?: string;
    updatedSemitrailerName?: string;
}

interface ITripFinishedExtra {
    reason?: string;
}

interface ITripScheduledStartChangedExtra {
    previousScheduledStart?: string;
    updatedScheduledStart?: string;
}

interface IStepSkippedExtra {
    stepName?: string;
}

interface IStepPlannedAtChangedExtra {
    stepName?: string;
    previousPlannedAt?: string;
    updatedPlannedAt?: string;
}

interface IVehicleAssignedExtra {
    licensePlate?: string;
}

interface IVehicleChangedExtra {
    previousLicensePlate?: string;
    updatedLicensePlate?: string;
}

interface IDriverAssignedExtra {
    driverName?: string;
}

interface IDriverChangedExtra {
    previousDriverName?: string;
    updatedDriverName?: string;
}

interface IVehiclePositionExtra {
    latitude?: string;
    longitude?: string;
}

interface ILocationChangedExtra {
    previousLocation?: string;
    updatedLocation?: string;
    checkpointIndex?: string;
}
interface ICheckpointReorderedExtra {
    fromCheckpointIndex?: string;
    toCheckpointIndex?: string;
}

interface IStopsExtra {
    stops?: {
        start: string;
        finish: string;
    }[];
}

interface ITripStatusChangedExtra {
    previousStatus?: string;
    updatedStatus?: string;
}

interface ISatelliteEntityNotFoundExtra {
    entityType?: 'driver' | 'vehicle' | 'carrier' | 'semitrailer';
    providedId?: string;
}

interface ILocationMissingZonesExtra {
    locationName?: string;
    missingZoneTypes?: string;
}

interface IUnfoldExtra {
    /** On the original, the openings of that unfold; on an opening, its original. */
    tripCodes?: string;
}

interface IScoreConfigChangeExtra {
    scoreConfigAction?: 'update';
    scoreConfigTripDefinitionId?: string;
    scoreConfigPrevious?: ScoreConfig;
    scoreConfigUpdated?: ScoreConfig;
}
